import { render, staticRenderFns } from "./PosCategrArticle.vue?vue&type=template&id=0b296f0b&"
import script from "./PosCategrArticle.vue?vue&type=script&lang=js&"
export * from "./PosCategrArticle.vue?vue&type=script&lang=js&"
import style0 from "./PosCategrArticle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports